export default __webpack_public_path__ + "static/media/icon-warning.19474a29.svg";